import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#step-bar-with-icon" }),
  /*#__PURE__*/_createTextVNode(" Step bar with icon ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " A variety of custom icons can be used in the step bar. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_steps, { active: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_step, {
            title: "Step 1",
            icon: "el-icon-edit"
          }),
          _createVNode(_component_el_step, {
            title: "Step 2",
            icon: "el-icon-upload"
          }),
          _createVNode(_component_el_step, {
            title: "Step 3",
            icon: "el-icon-picture"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}